import { render, staticRenderFns } from "./Collect3.vue?vue&type=template&id=f5ccdb1a&scoped=true&lang=pug&"
import script from "./Collect3.vue?vue&type=script&lang=ts&"
export * from "./Collect3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ccdb1a",
  null
  
)

export default component.exports